module.exports = {"closeButtonText":"Zamknij","thumbNailAlt":"Podgląd obrazu","next":"Następna strona","previous":"Poprzednia strona","addNote":"Dodaj notatkę..."}


//////////////////
// WEBPACK FOOTER
// ./translations/pl.json
// module id = 36
// module chunks = 0